import './CanSeeItSection.scss'

const CanSeeItSection = () => (
  <section className="lnn-section lnn-canSeeItSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-canSeeItSection__head">
        <h2>Why leadership.NET Can See It</h2>
      </div>

      <div className="lnn-canSeeItSection__content">
        <div className="lnn-canSeeItSection__intro">
          <p>This work comes from repeated exposure to real decision environments over time.</p>
          <p>Not theory. Not simulation.</p>
        </div>

        <div className="lnn-canSeeItSection__body">
          <div className="lnn-canSeeItSection__label">
            <p>Observation of:</p>
          </div>

          <ul className="lnn-canSeeItSection__evidence">
            <li>live leadership decisions</li>
            <li>real operational constraints</li>
            <li>real consequences</li>
          </ul>
        </div>

        <div className="lnn-canSeeItSection__closing">
          <p>Across those environments, the same pattern appears:</p>
          <p>
            leaders believe alignment has been achieved, but execution diverges because
            interpretation differs.
          </p>
        </div>
      </div>
    </div>
  </section>
)

export default CanSeeItSection
